import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { trackEvent } from "../../modules/analytics";

const formatGBP = (val) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: 0,
  }).format(val);

const LeaseExtensionResults = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { result, lease, contact } = state || {};
  const yearsRemaining = state?.yearsRemaining;

  useEffect(() => {
    if (result) {
      trackEvent("results_viewed", {
        extension_premium: result.extensionPremium,
        value_captured: result.valueCaptured,
      });
    }
  }, [result]);

  if (!result) {
    return (
      <div className="login-container mt-4">
        <p style={{ color: "red" }}>No results to display. Please go back.</p>
        <button onClick={() => navigate("/")}>Back to Search</button>
      </div>
    );
  }

  return (
    <div style={{ width: "80%", margin: "0 auto" }} className="mt-4">
      <h2 className="mb-1">Lease Extension Results</h2>
      <p style={{ color: "gray" }} className="mb-3">
        {lease?.dpa_single_address_label}
      </p>

      <table className="table table-bordered">
        <tbody>
          <tr>
            <th>Current {yearsRemaining}-year lease value</th>
            <td>{formatGBP(result.currentValue)}</td>
          </tr>
          <tr>
            <th>90-year extension premium</th>
            <td>{formatGBP(result.extensionPremium)}</td>
          </tr>
          <tr>
            <th>Total</th>
            <td>{formatGBP(result.total)}</td>
          </tr>
          <tr>
            <th>
              Value of new{" "}
              {result.extendedLeaseYears
                ? `${result.extendedLeaseYears}-year`
                : "extended"}{" "}
              lease
            </th>
            <td>{formatGBP(result.newLeaseValue)}</td>
          </tr>
          <tr>
            <th>Value captured from lease extension</th>
            <td>{formatGBP(result.valueCaptured)}</td>
          </tr>
        </tbody>
      </table>

      <p className="mt-3" style={{ color: "gray" }}>
        Lendle Broker Services are specialists in funding solutions for lease
        extension premiums and costs. We will contact you to explore how,
        working with us and our professional partners, we can fund the lease
        extension and the costs.
      </p>

      <button onClick={() => navigate("/")} className="mt-2">
        Back to Search
      </button>
    </div>
  );
};

export default LeaseExtensionResults;
